var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ai-stream-md ai-stream-md--math",
      attrs: { "aria-busy": _vm.showTypingDots ? "true" : "false" }
    },
    [
      !_vm.mdReady
        ? _c(
            "p",
            {
              staticClass: "ai-msg ai-msg--assistant ai-msg--assistant-fragment"
            },
            [
              _vm._v(_vm._s(_vm.displayText)),
              _vm.showTypingDots
                ? _c(
                    "span",
                    {
                      staticClass: "ai-stream-md__typing-dots",
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v(_vm._s(_vm.typingDotsLabel))]
                  )
                : _vm._e()
            ]
          )
        : _c("div", { staticClass: "ai-stream-md__rich-with-dots" }, [
            _c("div", {
              ref: "aiMdBody",
              staticClass:
                "ai-msg ai-msg--assistant markdown-body ai-stream-md__body",
              domProps: { innerHTML: _vm._s(_vm.sanitizedHtml) }
            })
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-71caee67", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-71caee67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/ai-streaming-text.vue
// module id = null
// module chunks = 